import { createRoutine } from "redux-saga-routines";

export const connectSocket = createRoutine('CONNECT_SOCKET');
export const closeSocket = createRoutine('CLOSE_SOCKET');
export const sendSkyBoxSignal = createRoutine('SEND_SKY_BOX_SIGNAL');
